var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldSelect, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { ALL_PLATFORMS } from 'lib-shared-legacy-types';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Field, Form, formValueSelector, reduxForm, } from 'redux-form';
import { ajaxSend } from 'api/api';
import { analytics } from 'app/utils/segment';
import { useNotifications } from 'hooks/useNotifications';
import { mapPlatform } from '../../platforms';
import { ApnsControls } from './apnsControls';
import { GcmControls } from './gcmControls';
// Type Hack - https://stackoverflow.com/questions/49749060/
const FieldCustom = Field;
const trimAndRemoveNl = (value) => value === null || value === void 0 ? void 0 : value.trim().replace(/(?:\r\n|\r|\n)/g, '');
const validate = (values) => {
    const errors = {};
    switch (values.platform) {
        case 'APNS':
        case 'APNS_SANDBOX':
            if (!trimAndRemoveNl(values.platformCredential))
                errors.platformCredential = 'Required';
            if (!trimAndRemoveNl(values.platformPrincipal))
                errors.platformPrincipal = 'Required';
            break;
        case 'GCM':
            if (!trimAndRemoveNl(values.platformCredential))
                errors.platformCredential = 'Required';
            break;
        default:
            errors.platform = 'Required';
            break;
    }
    return errors;
};
const FORM_NAME = 'submitPlatformForm';
const PLATFORM_ITEMS = ALL_PLATFORMS.map((p) => ({
    id: p,
    name: mapPlatform(p),
}));
function SubmitModalImpl(props) {
    const notify = useNotifications();
    const [loading, setLoading] = useState(false);
    const { certPassword, change, unavailablePlatforms, editPlatform, messengerId, show, handleSubmit, closeModal, refreshItems, destroy: destroyForm, selectedPlatform, } = props;
    useEffect(() => {
        if (!show) {
            destroyForm();
        }
    }, [destroyForm, show]);
    const isDuplicatePlatform = selectedPlatform && !editPlatform
        ? unavailablePlatforms.includes(selectedPlatform)
        : false;
    const platformItems = editPlatform
        ? PLATFORM_ITEMS
        : PLATFORM_ITEMS.filter((x) => !unavailablePlatforms.includes(x.id));
    const handleFormSubmit = (values) => __awaiter(this, void 0, void 0, function* () {
        if (isDuplicatePlatform || loading || props.invalid) {
            return;
        }
        analytics.pushNotificationPlatformFormSubmitted({
            mode: editPlatform ? 'update' : 'create',
        });
        setLoading(true);
        const { platform, platformCredential, platformPrincipal } = values;
        try {
            yield ajaxSend({
                path: `/v1/messengers/${messengerId}/platform_application`,
                method: 'PUT',
                data: {
                    platform: platform,
                    platformCredential,
                    platformPrincipal,
                },
            });
            closeModal();
            refreshItems();
            notify({
                title: 'Push notification platform was submitted',
                text: `"${platform}" push notification platform was submitted.`,
                icon: 'done',
                className: 'success',
                time: 5000,
            });
        }
        catch (e) {
            console.error('Failed to submit push notification platform', e);
            notify({
                title: 'An error occurred',
                text: `An error occurred when trying to submit the push notification platform.`,
                icon: 'exclamation',
                className: 'danger',
            });
        }
        setLoading(false);
    });
    const resetForm = () => {
        change('platformCredential', '');
        change('platformPrincipal', '');
        change('password', '');
    };
    const controlsForPlatform = () => {
        switch (selectedPlatform) {
            case 'GCM':
                return _jsx(GcmControls, {});
            case 'APNS':
            case 'APNS_SANDBOX':
                return (_jsx(ApnsControls, { addNotification: notify, certPassword: certPassword, change: change, resetForm: resetForm }));
            default:
                return null;
        }
    };
    return (_jsx(Modal, Object.assign({ isOpen: show, onClose: closeModal }, { children: _jsxs(Box, Object.assign({ width: "800px" }, { children: [_jsx(ModalHead, { title: editPlatform
                        ? `Edit "${mapPlatform(editPlatform)}" platform`
                        : 'Add a new push notification platform', onClose: closeModal }), _jsxs(Form, Object.assign({ onSubmit: handleSubmit(handleFormSubmit) }, { children: [_jsxs(ModalBody, { children: [_jsx(FieldCustom, { component: FieldSelect, items: platformItems, label: "Platform", name: "platform", disabled: !!editPlatform, placeholder: "Select platform", required: true, onChange: (_, newValue, prevValue) => {
                                        if (newValue !== prevValue) {
                                            // Reset form on platform switch
                                            resetForm();
                                        }
                                    } }), controlsForPlatform()] }), _jsx(ModalFoot, { cancelOnClick: closeModal, confirmName: "Submit platform", confirmOnClick: handleSubmit(handleFormSubmit), confirmProps: {
                                type: 'submit',
                                disabled: isDuplicatePlatform || props.invalid,
                                isLoading: loading,
                            } })] }))] })) })));
}
const valueSelector = formValueSelector(FORM_NAME);
const mapStateToProps = (state, ownProps) => ({
    selectedPlatform: valueSelector(state, 'platform'),
    certPassword: valueSelector(state, 'password'),
    initialValues: ownProps.editPlatform
        ? { platform: ownProps.editPlatform }
        : {},
});
export const SubmitModal = connect(mapStateToProps)(reduxForm({
    enableReinitialize: true,
    form: FORM_NAME,
    touchOnBlur: false,
    shouldError: () => true,
    validate,
})(connect(mapStateToProps)(SubmitModalImpl)));
